import React, { useContext, useRef } from "react";
import { MasterBannerContext } from '../../../contexts/MasterBannerContext';
import { SettingsBannerContext } from '../../../contexts/SettingsBannerContext';
import { getCustomKeyframe } from "../../../helpers/buildVideo";
import Button from "../../Button";
import './index.css';
import {GenerateAnimationAI } from "../../IA";
import { useEffect } from "react";
export default function CustomKeyframe(props) {
  const { master, setMaster } = useContext(MasterBannerContext);
  const { setReload, setError , AiAnimation, setAiAnimation} = useContext(SettingsBannerContext);
  const refNome = useRef(null);
  const refCSS = useRef(null);
  const type = props.type;
  const editCustom = props.custom;
  const editNome = editCustom ? editCustom.animation : "";
  const editCSS = editCustom ? editCustom.keyframe : "";

  useEffect(()=>{
    if(AiAnimation !== null){
      const name = AiAnimation.split('{')[0].trim().slice(1);
      refNome.current.value = name
      refCSS.current.value = AiAnimation
      setAiAnimation(null);
    }
    },[AiAnimation])


  function applyKeyframe() {
    const animation = getCustomKeyframe(refCSS.current.value);
    if (!animation.animationName || !animation.duration) {
      showError();
      return;
    }
    var copyBanner = JSON.parse(JSON.stringify(master));
    var custom = {
      animation: refNome.current.value,
      keyframeName: animation.animationName,
      keyframe: refCSS.current.value,
      type: type,
      duration: animation.duration,
      save: false
    };
    refNome.current.value = "";
    refCSS.current.value = "";
    const customArray = copyBanner.customKeyframe ? copyBanner.customKeyframe : [];
    customArray.push(custom);
    copyBanner.customKeyframe = customArray;
  
    setMaster(copyBanner);
    setReload(true);
    props.onClick();
  }

  function SaveKeyframe(){
    const animation = getCustomKeyframe(refCSS.current.value);
    if (!animation.animationName || !animation.duration) {
      showError();
      return;
    }
    var copyBanner = JSON.parse(JSON.stringify(master));
    for (var i = 0; copyBanner.customKeyframe.length; i++){
      if (copyBanner.customKeyframe[i].animation === editNome) {
        copyBanner.customKeyframe[i].animation = refNome.current.value;
        copyBanner.customKeyframe[i].keyframeName = animation.animationName;
        copyBanner.customKeyframe[i].keyframe = refCSS.current.value;
        copyBanner.customKeyframe[i].duration = animation.duration;
        break;
      }
    }
    const filteredCustomKeyframes = copyBanner.customKeyframe.filter((keyframe) => keyframe.save === true);
    localStorage.setItem('customKeyframes', JSON.stringify(filteredCustomKeyframes));
    setMaster(copyBanner);
    setReload(true);
    props.onClick();
  }

  function showError() {
    setError(
      {
        mensagem: "Keyframe inválido",
        lista: ["Utilizar padrão:", "\"animation: animation-name 1.4s forwards;\""],
        show: true
      }
    )
    return;
  }
  
  const placeholderCSS = () => {
    return `// Exemplo keyframe **    
    @keyframes animation-name {
      0% {
        opacity: ${type.toLowerCase() === "in" ? 0 : 1};
      }
      100% {
        opacity: ${type.toLowerCase() === "in" ? 1 : 0};
      }
    }
    .animation-name {
      animation: animation-name 1s forwards ${type.toLowerCase() === "out" ? "!important" : ""};
    }

    // Exemplo transition
    .animation-name {
      opacity: 0 !important;
      transition: all 1s ease-out;
    }  
    `
  }

  function setEG(evt) {
    if (evt) {
      refCSS.current.value = placeholderCSS();
      refNome.current.value = "animation-name";
    } else {    
      refCSS.current.value = "";
      refNome.current.value = "";
    }
  }

  return(
    <div className="root-custom-keyframe">
      <button onClick={() => props.preview(refCSS.current.value, refNome.current.value)}
      style={{margin: '-5px 0 0 190px', backgroundColor: '#FFFFFF', border: '1px solid #1B9ADA', borderRadius: '20px', fontWeight: 'bold',color: '#1B9ADA', width: '80px', height: '25px', cursor: 'pointer'}}>Preview</button>
      <span className="nomeAnima" >Nome animação</span>
            <div style={{display: 'flex',justifyContent: 'space-between', width: '92%'}}>
      <textarea ref={refNome} placeholder="Animation-name" style={{width: '215px', resize: 'none', height: '25px', border: '1px solid rgba(112, 112, 112, 0.3)', borderRadius: '3px', textAlign: 'start', verticalAlign: 'middle', 
       fontSize: '14px'}}>
        {editNome}
      </textarea>
      <GenerateAnimationAI/>
      </div>


      <div style={{display: 'flex', margin: '0px 0 0 0'}}>
        <span className="classeAnima">Classe de animação</span>      
      {editCustom === "new" ?
        <div style={{display: 'flex', alignItems: 'center', margin: '15px 0 0 20px'}}>
          <span style={{fontSize: '14px', margin: '-5px 0 0 0'}}>e.g. </span><input onChange={(evt) => setEG(evt.target.checked)} type="checkbox"/>
        </div> :
        <></>
      }
      </div>
      <textarea ref={refCSS} className="textArea" name="Text1" 
        cols="40" rows="5" placeholder={placeholderCSS()}>{editCSS}</textarea>
      <div style={{display: 'flex', width: '100%', justifyContent: 'space-evenly', marginTop: '15px'}}>
        <button onClick={() => props.onClick()} style={{width: '110px', height: '38px', cursor: 'pointer', borderRadius: '20px', border: '1px solid #1B9ADA', color: '#1B9ADA', fontWeight: 'bold', fontSize: '16px', backgroundColor: '#FFFFFF'}}>Voltar</button>
        {editCustom === "new" ?
          <button onClick={() => applyKeyframe()} style={{width: '110px', cursor: 'pointer', height: '38px', borderRadius: '20px', border: 'none', color: '#FFFFFF', fontWeight: 'bold', fontSize: '16px', background: 'transparent linear-gradient(180deg, #1B9ADA 0%, #027CB9 100%) 0% 0% no-repeat padding-box'}}>Aplicar</button> :
          <button onClick={() => SaveKeyframe()} style={{width: '110px', cursor: 'pointer', height: '38px', borderRadius: '20px', border: 'none', color: '#FFFFFF', fontWeight: 'bold', fontSize: '16px', background: 'transparent linear-gradient(180deg, #1B9ADA 0%, #027CB9 100%) 0% 0% no-repeat padding-box'}}>Salvar</button>
        }
      </div>
    </div>
  )
}